import { HttpCode } from '../types';

export class HttpError extends Error {
  public code: number;

  constructor(code: HttpCode) {
    super(code.toString());
    this.code = code;
  }
}
